import { DadataFIOResponse } from '../structures/response/dadata/DadataFIOResponse';
import apiClient from './apiClient';
import { DadataBankResponse } from '../structures/response/dadata/DadataBankResponse';
import { DadataAddressResponse } from '../structures/response/dadata/DadataAddressResponse';
import { DadataLegalType } from '../enum/DadataLegalType';
import { DadataInnResponse } from '../structures/response/dadata/DadataInnResponse';

export interface DadataSuggestion<T> {
  value: string;
  data: T;
}

export const suggestFIO = async (
  query: string,
  parts?: 'NAME' | 'SURNAME' | 'PATRONYMIC'
): Promise<{ suggestions: DadataSuggestion<DadataFIOResponse>[] }> => {
  const params = new URLSearchParams({
    query,
    parts: parts as string,
  });
  return apiClient
    .get(`dadata/suggest-fio?query=${params.toString()}`)
    .then((r) => r.data);
};

export const suggestBank = async (
  query: string
): Promise<{
  suggestions: DadataSuggestion<DadataBankResponse>[];
}> => apiClient.get(`dadata/bank?query=${query}`).then((r) => r.data);

export const suggestAddress = async (
  query: string
): Promise<{
  suggestions: DadataSuggestion<DadataAddressResponse>[];
}> => apiClient.get(`dadata/address?query=${query}`).then((r) => r.data);

export const partySuggest = async (
  query: string,
  type: DadataLegalType
): Promise<{
  suggestions: { value: string; data: DadataInnResponse }[];
}> =>
  apiClient
    .get(`dadata/party-suggest?query=${query}&type=${type}&count=10`)
    .then((r) => r.data);

export const findByInn = async (
  query: string,
  type: DadataLegalType
): Promise<{
  suggestions: { value: string; data: DadataInnResponse }[];
}> =>
  apiClient
    .get(`dadata/party?query=${query}&type=${type}&count=1`)
    .then((r) => r.data);
